import { getCurrentTimestamp } from "../../utils/moment";

export const storeAuthData = (data) => {
  const myData = { ...data, stored_at: getCurrentTimestamp() };
  localStorage.setItem('LoggedState', JSON.stringify(myData));
};

export const getAuthData = () => {
  const stored = localStorage.getItem('LoggedState');
  try {
    return stored ? JSON.parse(stored) : {};
  } catch (e) {
    console.error("Failed to parse auth data:", e);
    return {};
  }
};

export const setUserOnline = (status) => {
  localStorage.setItem('ONLINE', status);
};

export const getDomainSelcted = () => {
  const stored = localStorage.getItem('StoredDomain');
  return stored ? JSON.parse(stored) : null;
};

export const isUserOnline = () => {
  const status = localStorage.getItem('ONLINE');
  return status === null ? true : status === 'true';
};

export const saveInLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLocalStorage = (key) => {
  const stored = localStorage.getItem(key);
  return stored ? JSON.parse(stored) : null;
};

export const getSessinIdFromLS = () => {
  return localStorage.getItem("sessionId"); 
};


export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const updateDataInStorage = async (key, value) => {
  const data = await getAuthData();
  if (data) {
    data[key] = value;
    await storeAuthData(data);
  }
};

export const getSignupPath = () => localStorage.getItem('pathName');